import React, { Component } from "react";
import { CookiesProvider } from "react-cookie";
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import logo from "./logo.svg";
import "./App.scss";
import Main from "./Views/Main";

export default class App extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <CookiesProvider>
        <Router basename="/">
          <div className="App">
            <Switch>
              <Route exact path="/" render={(props) => <Main {...props} />}>
                <Redirect to="/et" />
              </Route>
              <Route path="/:lang" render={(props) => <Main {...props} />} />
            </Switch>
          </div>
        </Router>
      </CookiesProvider>
    );
  }
}
